module.exports = __webpack_public_path__ + "static/img/15c8ed99385056dd7e1e77465bc9eadc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sol_icon3.jpg
// module id = 9Akp
// module chunks = 1